import {
  FETCHING_EXCHANGE_QUOTE,
  EXCHANGE_QUOTE_FETCHED,
  EXCHANGE_QUOTE_FETCHING_FAILED,
  CONFIRMING_EXCHANGE_QUOTE,
  EXCHANGE_QUOTE_CONFIRMED,
  EXCHANGE_QUOTE_CONFIRMATION_FAILED,
  RESET_EXCHANGE_QUOTE_STATUS,
} from '../../actions/flight';

export const FETCHING = 'fetching';
export const FETCHED = 'fetched';
export const FETCHING_FAILED = 'fetchingFailed';
export const CONFIRMING = 'confirming';
export const CONFIRMED = 'confirmed';
export const CONFIRMATION_FAILED = 'confirmationFailed';

export default function exchangeQuoteStatus(state = null, action) {
  switch (action.type) {
    case FETCHING_EXCHANGE_QUOTE:
      return FETCHING;

    case EXCHANGE_QUOTE_FETCHED:
      return FETCHED;

    case EXCHANGE_QUOTE_FETCHING_FAILED:
      return FETCHING_FAILED;

    case CONFIRMING_EXCHANGE_QUOTE:
      return CONFIRMING;

    case EXCHANGE_QUOTE_CONFIRMED:
      return CONFIRMED;

    case EXCHANGE_QUOTE_CONFIRMATION_FAILED:
      return CONFIRMATION_FAILED;

    case RESET_EXCHANGE_QUOTE_STATUS:
      return null;

    default:
      return state;
  }
}
